import reducer from './reducers';

export { default as alternativesSelectors } from './selectors';
export { default as alternativesOperations } from './operations';
export { default as alternativesTypes } from './types';

export default reducer;
